import { grpc } from "@improbable-eng/grpc-web";
import { UnaryOutput } from "@improbable-eng/grpc-web/dist/typings/unary";
import {
  FileInfo,
  UploadFileRequest,
  UploadFileResponse,
} from "api/models/gamification-service/gamification_pb";
import { GamificationService } from "api/models/gamification-service/gamification_pb_service";
import {
  DurationFile,
  ID,
  PurposeFileDetails,
  RequestForGetAllMeditationFiles,
  RequestGetAllPurposeFileDetails,
  RequestPageable,
  ResponseAllPurposeFiles,
  SelectedFileDetailsResponseV2,
  SelectedMeditationFiles,
} from "api/models/guided-meditation-service/guided-meditation_pb";
import { GuidedMeditationService } from "api/models/guided-meditation-service/guided-meditation_pb_service";
import {
  GAMIFICATION_SERVICE_HOST,
  GUIDED_MEDITATION_SERVICE_HOST,
} from "api/serviceEndpoints";
import { forceLogout, getKeycloakToken } from "config/keycloak";
import { AppThunk } from "redux/store/store";
import {
  meditationListError,
  meditationListLoading,
  meditationListUpdated,
  meditationListUpdateImage,
  purposeFileListUpdate,
  purposeFileListUpError,
  purposeFileListUpLoading,
  purposeMeditationListError,
  purposeMeditationListLoading,
  purposeMeditationListUpdate,
  setCurrentDurationFile,
  setPurposeFile,
} from "../reducers/guidedMeditationReducer";

export const getDurationDetailsbyID =
  (id: number): AppThunk =>
  async (dispatch) => {
    try {
      const durationReq: ID = new ID();
      durationReq.setId(id);
      const jwtToken = await getKeycloakToken();
      grpc.unary(GuidedMeditationService.getDurationFileDetailsById, {
        request: durationReq,
        host: GUIDED_MEDITATION_SERVICE_HOST,
        metadata: {
          Authorization: `Bearer ${jwtToken}`,
        },
        onEnd: (res: UnaryOutput<DurationFile>) => {
          const { status, message } = res;
          if (status === grpc.Code.OK && message) {
            if (res.message) {
              dispatch(setCurrentDurationFile(res.message.toObject()));
            }
          } else if (status === grpc.Code.Unauthenticated) forceLogout();
        },
      });
    } catch {
      // console.error(err);
    }
  };
export const getAllMeditation =
  (
    pageSize: number,
    pageNumber: number,
    meditationType: 0 | 1 | 2 | 3 | 4
  ): AppThunk =>
  async (dispatch) => {
    try {
      dispatch(meditationListLoading());
      const meditationReq: RequestForGetAllMeditationFiles =
        new RequestForGetAllMeditationFiles();
      const pageable = new RequestPageable();
      pageable.setPagenumber(pageNumber);
      pageable.setPagesize(pageSize);
      meditationReq.setRequestpageable(pageable);
      meditationReq.setMeditationtype(meditationType);
      const jwtToken = await getKeycloakToken();
      grpc.unary(GuidedMeditationService.getAllMeditationFileDetails, {
        request: meditationReq,
        host: GUIDED_MEDITATION_SERVICE_HOST,
        metadata: {
          Authorization: `Bearer ${jwtToken}`,
        },
        onEnd: (res: UnaryOutput<SelectedMeditationFiles>) => {
          const { status, message } = res;
          if (status === grpc.Code.OK && message) {
            if (res.message) {
              dispatch(
                meditationListUpdated(
                  res.message.toObject().selectedmeditationfileList
                )
              );
            }
          } else if (status === grpc.Code.Unauthenticated) forceLogout(); else {
            dispatch(meditationListUpdated([]));
          }
        },
      });
    } catch {
      dispatch(meditationListError());
    }
  };


export const getAllPurposeFile =
  (
    language: 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12 | 13 | 14 | 15 | 16 | 17 | 18 | 19 | 20 | 21 | 22
  ): AppThunk =>
  async (dispatch) => {
    try {
      dispatch(purposeFileListUpLoading());
      const reqBody: RequestGetAllPurposeFileDetails =
        new RequestGetAllPurposeFileDetails();
      reqBody.setUsertype(2);
      reqBody.setSelectedlanguage(language);
      const jwtToken = await getKeycloakToken();
      grpc.unary(GuidedMeditationService.getAllPurposeFileDetails, {
        request: reqBody,
        host: GUIDED_MEDITATION_SERVICE_HOST,
        metadata: {
          Authorization: `Bearer ${jwtToken}`,
        },
        onEnd: (res: UnaryOutput<ResponseAllPurposeFiles>) => {
          const { status, message } = res;
          if (status === grpc.Code.OK && message) {
            if (res.message) {
              dispatch(
                purposeFileListUpdate(
                  res.message.toObject().listofpurposefileList
                )
              );
            }
          } else if (status === grpc.Code.Unauthenticated) forceLogout();
        },
      });
    } catch {
      dispatch(purposeFileListUpError());
    }
  };

export const getPurposeFileDetailsById =
  (id: number): AppThunk =>
  async (dispatch) => {
    try {
      const reqBody: ID = new ID();
      reqBody.setId(id);
      const jwtToken = await getKeycloakToken();
      grpc.unary(GuidedMeditationService.getPurposeFileDetailsById, {
        host: GUIDED_MEDITATION_SERVICE_HOST,
        request: reqBody,
        metadata: {
          Authorization: `Bearer ${jwtToken}`,
        },
        onEnd: (res: UnaryOutput<PurposeFileDetails>) => {
          const { status, message } = res;
          if (status === grpc.Code.OK && message) {
            dispatch(setPurposeFile(message.toObject()));
          } else if (status === grpc.Code.Unauthenticated) forceLogout();
        },
      });
    } catch {
      // console.log(err);
    }
  };


export const upload =
  (data: any): AppThunk =>
  async (dispatch) => {
    const payload = new UploadFileRequest();
    const fileInfo = new FileInfo();
    payload.setFile(data.icon);
    fileInfo.setName(data.name);
    fileInfo.setFormat(data.format);
    payload.setInfo(fileInfo);
    const jwtToken = await getKeycloakToken();
    grpc.unary(GamificationService.UploadFile, {
      request: payload,
      host: GAMIFICATION_SERVICE_HOST,
      metadata: {
        Authorization: `Bearer ${jwtToken}`,
      },
      onEnd: (res: UnaryOutput<UploadFileResponse>) => {
        const { status, statusMessage, headers, message, trailers } = res;
        if (status === grpc.Code.OK && message) {
          dispatch(meditationListUpdateImage(message?.toObject().url));
          return message.toObject;
        } else if (status === grpc.Code.Unauthenticated) forceLogout();
      },
    });
  };

export const getAllMeditationFileDetailsV2 =
  (
    pageSize: number,
    pageNumber: number,
    meditationType: 0 | 1 | 2 | 3 | 4
  ): AppThunk =>
  async (dispatch) => {
    try {
      dispatch(purposeMeditationListLoading());
      const meditationReq: RequestForGetAllMeditationFiles =
        new RequestForGetAllMeditationFiles();
      const pageable = new RequestPageable();
      pageable.setPagenumber(pageNumber);
      pageable.setPagesize(pageSize);
      meditationReq.setRequestpageable(pageable);
      meditationReq.setMeditationtype(meditationType);
      const jwtToken = await getKeycloakToken();
      grpc.unary(GuidedMeditationService.GetAllMeditationFileDetailsV2, {
        request: meditationReq,
        host: GUIDED_MEDITATION_SERVICE_HOST,
        metadata: {
          Authorization: `Bearer ${jwtToken}`,
        },
        onEnd: (res: UnaryOutput<SelectedFileDetailsResponseV2>) => {
          const { status, message } = res;
          if (status === grpc.Code.OK && message) {
            if (res.message) {
              dispatch(purposeMeditationListUpdate(res.message.toObject()));
            }
          } else if (status === grpc.Code.Unauthenticated) forceLogout(); else {
            dispatch(
              purposeMeditationListUpdate({
                meditationfiledetailsv2List: [],
                totalcount: 0,
              })
            );
          }
        },
      });
    } catch  {
      dispatch(purposeMeditationListError());
    }
  };
